export const userServiceUrl =
  (window.location.hostname == 'providernri.theelderlywellness.com') ? 'https://elderly-nri-service.theelderlywellness.com/api' : "https://elderly-nri-service-staging.theelderlywellness.com/api";
